import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { TableSort } from 'components/WrappedComponents/Table/types';
import { SortOptions } from 'hooks/dossiers/useSearchDossierSummaries';
import FOFilterProvider from 'hooks/FOFilterStoreContext';
import PaginationProvider, {
  DictTablePagination,
  PAGINATION_DICT_DEFAULT,
} from 'hooks/PaginationStoreContext';
import SortProvider from 'hooks/SortStoreContext';
import { useActionsRequises } from 'hooks/useActionsRequises';
import Dashboard from 'pages/forces-de-l-ordre/Dashboard';
import { DashboardForcesOrdreFilterForm } from 'pages/forces-de-l-ordre/Dashboard/types';
import PageDossier from 'pages/forces-de-l-ordre/PageDossier';
import { NOT_FOUND_PATH } from 'utils/enumData';

import PageComptes from './Comptes/PageComptes';

const FoRouter = (): React.ReactElement => {
  const [pagination, setPagination] = useState<DictTablePagination>(
    PAGINATION_DICT_DEFAULT,
  );
  const [filter, setFilter] = useState<Partial<DashboardForcesOrdreFilterForm>>(
    {},
  );
  const [sort, setSort] = useState<Partial<TableSort<SortOptions | undefined>>>(
    {
      IMMATRICULATION: true,
    },
  );

  const foActionsRequises = useActionsRequises();

  return (
    <SortProvider value={{ sort: sort, setSort: setSort }}>
      <PaginationProvider
        value={{ pagination: pagination, setPagination: setPagination }}
      >
        <FOFilterProvider
          value={{
            filter: filter,
            setFilter: setFilter,
            actionsRequises: foActionsRequises,
          }}
        >
          <Routes>
            <Route path="" element={<Dashboard />} />
            <Route path="dossier/:id" element={<PageDossier />} />
            <Route
              path="*"
              element={<Navigate replace to={NOT_FOUND_PATH} />}
            />
            <Route path="comptes" element={<PageComptes />} />
          </Routes>
        </FOFilterProvider>
      </PaginationProvider>
    </SortProvider>
  );
};

export default FoRouter;
